var __rspack_ns_object = JSON.parse('{"Sex":"Sexe","Age":"Âge","MRN":"MRN","Thickness":"Épaisseur","Spacing":"Espacement","Scanner":"Scanner"}')